import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#4fd1c5] disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#4fd1c5] text-[#0f2424] hover:bg-[#3dbdb2]',
    outline: 'border border-[#4fd1c5] text-[#4fd1c5] hover:bg-[#4fd1c5]/10',
    ghost: 'text-gray-300 hover:text-white hover:bg-white/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-242">
      {children}
    </button>;
}